module.exports = __webpack_public_path__ + "static/media/click-high-03.f2fad4a4.mp3";